// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import InnoleafJourneysPage from "../pages/InnoleafJourneys/InnoleafJourneys";
const __wvcRoutePaths = ["/", "/InnoleafJourneysPage", "/innoleaf-journeys"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["about-us", "aboutuspage", "cart", "cartpage", "checkout", "checkoutpage", "contact-us", "contactuspage", "fraud-awareness-vendor-protection", "fraudawarenessvendorprotectionpage", "innoleaf", "innoleaf-journeys", "innoleaf-reviews-customer-experiences", "innoleafjourneyspage", "innoleafpage", "innoleafreviewsandcustomerexperiencespage", "international-escapes", "international-holiday-packages", "internationalescapespage", "internationalholidaypackagespage", "post", "privacy-policy", "privacypolicypage", "refund-policy", "refundpolicypage", "shop", "shoppage", "soloist-expeditions", "soloistexpeditionspage", "stories", "storiespage", "term", "terms-and-conditions", "termsandconditionspage", "why-choose-innoleaf", "whychooseinnoleafpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      <Route path={__wvcRoutePaths[0]} element={<InnoleafJourneysPage />} />
      <Route path={__wvcRoutePaths[1]} element={<InnoleafJourneysPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[2]} element={<InnoleafJourneysPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
